import { Col, Form, Row, Typography } from "antd";
import { MazakaButton } from "apps/Common/MazakaButton";
import { MazakaForm } from "apps/Common/MazakaForm";
import useMazakaForm from "hooks/useMazakaForm";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";

import { MazakaPassword } from "apps/Common/MazakaPassword";

import { changePassword } from "../Services";
import { useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import { useState } from "react";
import PageTitle from "apps/Common/PageTitle";
import { Helmet } from "react-helmet-async";

const ChangePassword = () => {
  const [form] = Form.useForm();
  const { formActions, mazakaForm } = useMazakaForm(form);
  const { userInfoes } = useSelector((state: RootState) => state.profile);
  const [isResetPassValidation, setIsResetPassValidtion] = useState<boolean>(false);


  const handleOnFinish = async () => {
    mazakaForm.setLoading();
    let formValues = form.getFieldsValue();
    formValues["userId"] = userInfoes?.id?.toString()
   

    try {
      const response = await changePassword(formValues);
      mazakaForm.setSuccess(1000, () => response.message);
      form.resetFields()
      setIsResetPassValidtion(true)
      
   
    } catch (error: any) {
      mazakaForm.setFailed(2000, error?.message);
      openNotificationWithIcon("default", error?.message);

      console.log("Şifre degistirme sırasında bir hata oluştu", error);
    }
  };

 

  return (
    <>
      <Col span={24} >
      <Helmet>
                    <title className="capitalize">{"Şifre Güncelleme"}</title>
                  </Helmet>
        <MazakaForm
          submitButtonVisible={false}
          form={form}
          onFinish={handleOnFinish}
        >
          <Row
           gutter={[
            { xs: 10, md:10 , xl:10 }, 
            { xs:10 , md: 15, xl:20}   
          ]}
          className="">
            {/* <Col span={24} className="!flex justify-center">
            <PageTitle
            title="Şifre Değişikliği"
            />
            
            </Col> */}
            <MazakaPassword
              xs={24}
              name={"currentPassword"}
              label={"Eski Şifre"}
              className="!m-0"
              inputClassName="!bg-[#f7f7f7] !p-2"
              placeholder="Eski Şifre"
              rules={[{required:true,message:""}]}
              isShowDescriptionPass={false}
              
            />
            <MazakaPassword
              xs={24}
              name={"newPassword"}
              isResetPassValidation={isResetPassValidation}
              setIsResetPassValidation={setIsResetPassValidtion}
              label={"Yeni Şifre"}
              className="!m-0"
              inputClassName="!bg-[#f7f7f7] !p-2"
              placeholder="Yeni Şifre"
              rules={[{required:true,message:""}]}
            />

            <Col span={24}>
              <MazakaButton
                className="!p-4 !bg-[#FFC502] !text-black"
                htmlType="submit"
                block
                processType={formActions.submitProcessType}
              >
                Şifreyi Değiştir
              </MazakaButton>
            </Col>
          </Row>
        </MazakaForm>
      </Col>
    </>
  );
};

export default ChangePassword;
